module.exports = __webpack_public_path__ + "media/images/main/work2-acf5c0f2f211df7236e2db15d64631c0.jpg";